// CSS 가져오기
// import '../styles/admin/addCss.css';
import '../../styles/admin/admin.css';
import '../../styles/admin/adminHeader.css';
import '../../styles/admin/common.css';
import '../../styles/admin/popUp.css';
import '../../styles/admin/reset.css';
import '../../styles/admin/style.css';

import UpdatePassword from '../../components/admin/header/UpdatePassword';

export default function Admin() {
  return (
    <>
      <UpdatePassword></UpdatePassword>
    </>
  );
}
